module.exports = __webpack_public_path__ + "img/strength_icon3.c6ee1282.png";